const settings = {
    GQL_URL: process.env.REACT_APP_GQL_URL || 'http://localhost:3000/api/graphql',
    SOCKETS_URL: process.env.REACT_APP_SOCKETS_URL || 'http://localhost:3001',
    SERVER_URL: process.env.REACT_APP_SERVER_URL || process.env.SERVER_URL || 'http://localhost:3000',
    UI_SERVER_URL: process.env.REACT_APP_UI_SERVER_URL || 'http://localhost:3000',
};

export { settings };
